module.exports = __webpack_public_path__ + "static/media/Email.fe0a0b94.svg";